import { useCallback, useEffect, useRef, useState } from 'react';
import { useInterval } from '../../../hooks';
export function useClockState(clock, timing) {
    const [isStarted, setIsStarted] = useState(clock.isRunning);
    const [isRunning, setIsRunning] = useState(clock.isRunning);
    const [isEnded, setIsEnded] = useState(false);
    const pollClock = useCallback(() => {
        return timing.lastPosition(clock.now);
    }, [clock, timing]);
    const [position, setPosition] = useState(pollClock);
    useEffect(() => {
        setIsStarted(clock.isRunning);
        setIsRunning(clock.isRunning);
        setIsEnded(false);
        setPosition(pollClock());
    }, [clock, pollClock]);
    const positionRef = useRef(position);
    const updatePosition = useCallback(() => {
        const position = pollClock();
        if (position.absTick != positionRef.current.absTick) {
            positionRef.current = position;
            setPosition(positionRef.current);
        }
    }, [pollClock]);
    useEffect(() => {
        const handleSeek = (timestamp) => {
            if (timestamp >= 0) {
                setIsStarted(true);
            }
            if (timing.lastTick != null && timestamp < timing.tickTimestamp(timing.lastTick)) {
                setIsEnded(false);
            }
            updatePosition();
        };
        const handlePause = () => {
            setIsRunning(false);
            updatePosition();
        };
        const handleResume = () => {
            setIsStarted(true);
            setIsRunning(true);
            updatePosition();
        };
        const handleEnd = () => {
            setIsEnded(true);
            setIsRunning(false);
            updatePosition();
        };
        const handleReset = () => {
            setIsStarted(clock.isRunning);
            setIsEnded(false);
            setIsRunning(clock.isRunning);
            updatePosition();
        };
        clock.addEventListener('resumed', handleResume);
        clock.addEventListener('ended', handleEnd);
        clock.addEventListener('seeked', handleSeek);
        clock.addEventListener('paused', handlePause);
        clock.addEventListener('reset', handleReset);
        return () => {
            clock.removeEventListener('seeked', handleSeek);
            clock.removeEventListener('resumed', handleResume);
            clock.removeEventListener('paused', handlePause);
            clock.removeEventListener('ended', handleEnd);
            clock.removeEventListener('reset', handleReset);
        };
    }, [clock, timing, updatePosition]);
    useEffect(() => {
        updatePosition();
    }, [clock, updatePosition]);
    useInterval(() => {
        if (isRunning) {
            updatePosition();
        }
    }, 25);
    return { isRunning, isEnded, isStarted, position };
}
//# sourceMappingURL=ClockState.js.map